import { Auth } from "aws-amplify";

//method to manually trigger a token refresh with cognito
export const refreshToken = async () => {
  try {
    const cognitoUser = await Auth.currentAuthenticatedUser();
    const currentSession = await Auth.currentSession();
    cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
      const { idToken } = session;
      return idToken.getJwtToken();
    });
  } catch (e) {
    console.error("Unable to refresh Token", e);
  }
};

export const getSessionToken = async () => {
  try {
    Auth.currentAuthenticatedUser().catch((error) => {
      Auth.signOut();
      throw error;
    });
    //get current session (this should manager the refresh token for us)
    const session = await Auth.currentSession();
    const idToken = await session.getIdToken();
    const jwtToken = await idToken.getJwtToken();
    //additional check to confirm token not revoked
    //get token expiry date (unix format)
    const unixExp = idToken.payload?.exp;
    //get datetime in unix
    const unixNow = Math.round(new Date().getTime() / 1000);
    //check token valid, if not, trigger manual refresh
    if (unixExp < unixNow) {
      const tokenFromRefresh = await refreshToken();
      return `Bearer ${tokenFromRefresh}`;
    }
    return `Bearer ${jwtToken}`;
  } catch (err) {
    console.error("getTokenError ", err);
    return err;
  }
};
